import React from 'react';

interface AnimatedMenuIconProps {
  isOpen: boolean;
  className?: string;
}

// Pure CSS transform-based animated hamburger to X icon
const AnimatedMenuIcon: React.FC<AnimatedMenuIconProps> = ({ isOpen, className }) => {
  return (
    <div className={className} aria-hidden>
      <span
        className={`block h-[2px] w-6 bg-current rounded transition-transform duration-300 ease-[cubic-bezier(0.4,0,0.2,1)] ${
          isOpen ? 'translate-y-[8px] rotate-45' : 'translate-y-0 rotate-0'
        }`}
      />
      <span
        className={`block h-[2px] w-6 bg-current rounded my-[6px] transition-opacity duration-300 ease-[cubic-bezier(0.4,0,0.2,1)] ${
          isOpen ? 'opacity-0' : 'opacity-100'
        }`}
      />
      <span
        className={`block h-[2px] w-6 bg-current rounded transition-transform duration-300 ease-[cubic-bezier(0.4,0,0.2,1)] ${
          isOpen ? '-translate-y-[8px] -rotate-45' : 'translate-y-0 rotate-0'
        }`}
      />
    </div>
  );
};

export default AnimatedMenuIcon;


